const matches = (value, id) => value && String(value.convocatoria?.id) === String(id);
const percent = (value, expected) => expected ? Number(((value / expected) * 100).toFixed(2)) : null;

// Mixed counts replace legacy counts; metadata and target retain their independent provenance.
export function composeReviewSummary({ convocatoriaId, legacy, mixed, meta }) {
  const base = matches(legacy, convocatoriaId) ? legacy : null;
  const counts = matches(mixed, convocatoriaId) ? mixed : null;
  if (!base && !counts && !meta) return null;
  const target = meta || base?.target;
  const selected = counts?.progress || base?.progress;
  const expected = target?.expected;
  const progress = selected ? { ...selected } : undefined;
  if (progress && expected !== undefined) {
    const transcribed = progress.transcribed ?? progress.total;
    progress.remaining = expected === null ? null : Math.max(expected - transcribed, 0);
    progress.transcriptionPercent = percent(transcribed, expected);
    progress.verificationPercent = percent(progress.verified, expected);
    progress.overTarget = expected === null ? false : transcribed > expected;
  }
  return {
    ...base,
    convocatoria: { ...counts?.convocatoria, ...(counts?.convocatoria?.proyectoId
      ? { projectId: counts.convocatoria.proyectoId } : {}), ...base?.convocatoria },
    target,
    progress,
    sources: counts?.sources ?? base?.sources,
    countSource: counts?.progress ? "MIXED" : base?.progress ? "LEGACY" : "UNAVAILABLE",
  };
}
